export default __webpack_public_path__ + "static/media/nav-utensils-red.b500dcd3.svg";